module.exports = __webpack_public_path__ + "img/tu_file_mov.c49e94d8.svg";